"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var UsrPermissionAllowedDocsList = /** @class */ (function (_super) {
    __extends(UsrPermissionAllowedDocsList, _super);
    function UsrPermissionAllowedDocsList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchTitleInput = null;
        return _this;
    }
    UsrPermissionAllowedDocsList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID_STATE = this.props.state.Subscribe("*", function (id, data) {
            _this.setState({ page_size: data.tablePageSize });
        });
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                doc_category_filter: data.doc_category_filter
            });
        });
        this.setState({
            data: this.props.data.DATA.data,
            totalRows: 0,
            doc_category_filter: this.props.data.DATA.doc_category_filter,
            page_size: this.props.state.getTablePageSize()
        }, function () {
            _this.props.data.LoadData(_this.props.record.key);
        });
        this.props.state.setExtBreadCrumbPath(["Настройка документов"]);
    };
    UsrPermissionAllowedDocsList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    UsrPermissionAllowedDocsList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    UsrPermissionAllowedDocsList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    UsrPermissionAllowedDocsList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    UsrPermissionAllowedDocsList.prototype.getColumns = function () {
        var _this = this;
        var _title_filter = this.state.searchTitleFilter;
        return [
            {
                title: 'Категория документа',
                dataIndex: this.props.data.dk_doc_category,
                key: this.props.data.dk_doc_category,
                filters: this.state.doc_category_filter,
                filterMultiple: true,
                onFilter: function (value, record) { return record.doc_category.includes(value); },
                width: 200
            }, {
                title: 'Название документа',
                dataIndex: this.props.data.dk_doc_title,
                key: this.props.data.dk_doc_title,
                render: function (text, record, index) {
                    return (React.createElement("div", null,
                        React.createElement(FontAwesome_1.FA, { left: true, icon: record.doc_icon, kind: record.doc_icon_kind }),
                        " ",
                        record.doc_title,
                        " "));
                },
                filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                    React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u0438\u043C\u0435\u043D\u0438", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                    React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                    React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                filteredValue: _title_filter,
                filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                onFilter: function (value, record) { return record.doc_title.toLowerCase().includes(value.toLowerCase()); },
                onFilterDropdownVisibleChange: function (visible) {
                    if (visible) {
                        setTimeout(function () {
                            _this.searchTitleInput.focus();
                        });
                    }
                },
                width: 200
            }, {
                title: 'Права доступа',
                dataIndex: this.props.data.dk_doc_permission_title,
                key: this.props.data.dk_doc_permission_title,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        React.createElement(TableActionConfig_1.default, { hint: "\u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigAccessClick(record); } }),
                        "  ",
                        record.doc_permission_title));
                },
            }, {
                title: 'Режим отображения',
                dataIndex: this.props.data.dk_doc_view_title,
                key: this.props.data.dk_doc_view_title,
                width: 200,
                render: function (text, record, idx) {
                    return (React.createElement("div", null,
                        React.createElement(TableActionConfig_1.default, { hint: "\u043D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C", onClick: function () { _this.onConfigViewClick(record); } }),
                        "  ",
                        record.doc_view_title));
                },
            }, {
                title: 'Создан',
                dataIndex: this.props.data.dk_date_added2,
                key: this.props.data.dk_date_added2,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_added2.format(_this.props.state.getDateTimeFormat())));
                },
                width: 200
            }, {
                title: 'Изменен',
                dataIndex: this.props.data.dk_date_changed2,
                key: this.props.data.dk_date_changed2,
                render: function (text, record, idx) {
                    return (React.createElement("div", null, record.date_changed2.format(_this.props.state.getDateTimeFormat())));
                },
                width: 200
            }
        ];
    };
    UsrPermissionAllowedDocsList.prototype.onConfigAccessClick = function (record) {
        var _this = this;
        this.props.docAccessAvail.LoadAccessData(record.doc_identity, function () {
            _this.props.dlgSelectKeyValue
                .SetTitle("Выберите параметры доступа")
                .SetViewData(_this.props.docAccessAvail.DATA.data)
                .SetOnSelectClick(function (key, val) {
                _this.props.data.doSetAccessDocumentPermission({
                    admin_permission_id: _this.props.record.key,
                    doc_identity: record.doc_identity,
                    access_type_code: key
                }, function () {
                    _this.props.dlgSelectKeyValue.Close();
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u0414\u043E\u0441\u0442\u0443\u043F \u043A \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0443 ",
                        React.createElement("b", null,
                            "[",
                            record.doc_title,
                            "]"),
                        " \u0431\u044B\u043B \u0438\u0437\u043C\u0435\u043D\u0435\u043D"));
                });
            })
                .SetOnCloseClick(function () {
                _this.props.dlgSelectKeyValue.Close();
            })
                .Show();
        });
    };
    UsrPermissionAllowedDocsList.prototype.onConfigViewClick = function (record) {
        var _this = this;
        this.props.docAccessAvail.LoadViewData(record.doc_identity, function () {
            _this.props.dlgSelectKeyValue
                .SetTitle("Выберите параметры доступа")
                .SetViewData(_this.props.docAccessAvail.DATA.data)
                .SetOnSelectClick(function (key, val) {
                _this.props.data.doSetViewDocumentPermission({
                    admin_permission_id: _this.props.record.key,
                    doc_identity: record.doc_identity,
                    view_type_code: key
                }, function () {
                    _this.props.dlgSelectKeyValue.Close();
                    notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 ",
                        React.createElement("b", null,
                            "[",
                            record.doc_title,
                            "]"),
                        " \u0431\u044B\u043B\u043E \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u043E"));
                });
            })
                .SetOnCloseClick(function () {
                _this.props.dlgSelectKeyValue.Close();
            })
                .Show();
        });
    };
    UsrPermissionAllowedDocsList.prototype.onToolBarClick = function (action) {
        if (action === "refresh") {
            this.props.data.LoadData(this.props.record.key);
        }
        /*if (action === "create") {
            this.props.dialog
                .SetOnCloseClick(() => { this.props.dialog.Close() })
                .SetOnSelectClick((key, val) => {
                    this.props.data.DoAddAccess(this.props.record.key, key, ()=>{
                        this.props.dialog.Close();
                        notificationHelper.ShowTopRightNotification(<div>Доступ администратора <b>[{val}]</b> был успешно разрешен</div>)
                    })
                })
                .Show();

        }*/
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    UsrPermissionAllowedDocsList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { refresh: "Обновить", back: "Назад" }, onClick: this.onToolBarClick.bind(this) }),
            React.createElement(antd_1.Table, { locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, pagination: {
                    pageSize: this.state.page_size,
                    showSizeChanger: true,
                    total: this.state.totalRows,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u0412\u0441\u0435\u0433\u043E : ",
                        data.length,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) {
                    return (React.createElement("div", null,
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key,
                            "] "),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0418\u0437\u043C\u0435\u043D\u0435\u043D:"),
                            " [",
                            record.date_changed2.format(_this.props.state.getDateTimeFormat()),
                            "]"),
                        React.createElement("div", null,
                            React.createElement("b", null, "\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442:"),
                            " [",
                            record.doc_identity,
                            "]")));
                } })));
    };
    return UsrPermissionAllowedDocsList;
}(React.Component));
exports.default = UsrPermissionAllowedDocsList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/usr_permissions_list/ui/component/UsrPermissionAllowedDocsList.tsx
// module id = 1889
// module chunks = 0